import React, { useCallback, useState, useEffect, useRef } from 'react';
import { parse } from 'query-string';

import { indexSearch } from '../services/algolia';
import SearchResultsWrapper from './SearchResultsWrapper';
import Pager from '../../../common/Pager';

export default function FacetList({ facetListData }) {
  const rootRef = useRef();

  const [page, setPage] = useState(() => {
    const query = parse(window.location.search);

    if (query.page) {
      return parseInt(query.page);
    }

    return 1;
  });

  const [results, setResults] = useState([]);
  const [nbPages, setNbPages] = useState(0);
  const [nbResults, setNbResults] = useState(0);

  const handleSearch = useCallback(
    (page) => {
      let filters = '';

      facetListData.facetValues.split(',').forEach((value) => {
        filters = '' === filters ? filters : filters + ' OR ';
        filters = filters + facetListData.facetName + ':' + value;
      });

      const zerobasedPage = page - 1;

      indexSearch(undefined, facetListData.language, zerobasedPage, 15, filters).then(
        (response) => {
          setResults(response.hits);
          setNbResults(response.nbHits);
          setNbPages(response.nbPages);
        },
      );
    },
    [facetListData],
  );

  useEffect(() => {
    handleSearch(page);
  }, [handleSearch, page]);

  const onPageChange = useCallback((page) => {
    setPage(page);

    history.pushState({}, '', window.location.pathname + '?page=' + page);

    rootRef.current.scrollIntoView(true);
  }, []);

  return (
    <section ref={rootRef} className="crtSection has-padding">
      <SearchResultsWrapper results={results} nbResults={nbResults} searchData={facetListData} />
      {nbPages > 1 ? (
        <Pager page={page} onPageChange={onPageChange} pageCount={nbPages} data={facetListData} />
      ) : null}
    </section>
  );
}
